import React, { createContext, useState, useEffect } from "react";
import { url } from "../Components/url";
import { fetchWithAuth } from "../Components/FetchWithAuth";
import { clearAuthSession } from "../Components/clearAuthSession";

// Create the RoleContext
export const RoleContext = createContext();

// Create a provider component
export const RoleProvider = ({ children }) => {
    // Get the role from localStorage if available
    const storedRole = localStorage.getItem("role") || "";

    const [role, setRole] = useState(storedRole);

    // Keep localStorage in sync (including clear on logout / empty role)
    useEffect(() => {
        if (role) {
            localStorage.setItem("role", role);
        } else {
            localStorage.removeItem("role");
        }
    }, [role]);

    // Re-fetch role from server once on mount when a session username exists
    // (same source as SideBar) so ProtectedRoute does not rely only on stale localStorage.
    useEffect(() => {
        const username = localStorage.getItem("username");
        if (!username) return undefined;

        let cancelled = false;
        (async () => {
            try {
                const response = await fetchWithAuth(`${url}/get_user/${username}`, {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                    credentials: "include",
                });
                if (!response || cancelled) return;
                const data = await response.json();
                if (data?.role && !cancelled) {
                    setRole(data.role);
                }
            } catch (err) {
                if (cancelled) return;
                // Session gone / unauthorized — drop stale identity so login page stops looping
                if (err?.status === 401) {
                    clearAuthSession({ redirect: false });
                    setRole("");
                }
            }
        })();

        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <RoleContext.Provider value={{ role, setRole }}>
            {children}
        </RoleContext.Provider>
    );
};
